import React from 'react';
import { ExternalLink } from 'lucide-react';

const Ringraziamenti = () => {
  const photoCredits = [
    {
      id: 1,
      page: "Homepage Hero",
      photographer: "Jonathan Borba",
      photoUrl: "https://unsplash.com/photos/woman-wearing-black-sports-bra-reaching-arms-up-R0y_bEUjiom",
      photographerUrl: "https://unsplash.com/@jonathanborba"
    },
    {
      id: 2,
      page: "Chi Siamo - Team",
      photographer: "Unsplash Contributors",
      photoUrl: "https://unsplash.com",
      photographerUrl: "https://unsplash.com"
    },
    {
      id: 3,
      page: "Servizi - Consulenza Nutrizionale",
      photographer: "Unsplash Contributors",
      photoUrl: "https://unsplash.com",
      photographerUrl: "https://unsplash.com"
    },
    {
      id: 4,
      page: "Servizi - Fisioterapia",
      photographer: "Unsplash Contributors",
      photoUrl: "https://unsplash.com",
      photographerUrl: "https://unsplash.com"
    },
    {
      id: 5,
      page: "Risultati - Training Classes",
      photographer: "Unsplash Contributors",
      photoUrl: "https://unsplash.com",
      photographerUrl: "https://unsplash.com"
    }
  ];

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-black text-white mb-4">
          Ringraziamenti
        </h1>
        <p className="text-lg text-gray-400 mb-12">
          Questo sito utilizza immagini gratuite da <a href="https://unsplash.com" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-400 underline">Unsplash</a>. 
          Ringraziamo i fotografi per il loro eccellente lavoro.
        </p>

        {/* Photo Credits */}
        <div className="space-y-6">
          {photoCredits.map((credit) => (
            <div 
              key={credit.id}
              className="bg-white/5 border border-white/10 rounded-lg p-6 hover:bg-white/10 transition-all duration-300"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-white mb-2">
                    {credit.page}
                  </h3>
                  <p className="text-gray-400 text-sm mb-3">
                    Foto di{' '}
                    <a 
                      href={credit.photographerUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-orange-500 hover:text-orange-400 underline"
                    >
                      {credit.photographer}
                    </a>
                  </p>
                </div>
                <a
                  href={credit.photoUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label="Vedi foto su Unsplash"
                >
                  <ExternalLink className="w-5 h-5" />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Unsplash License */}
        <div className="mt-12 p-6 bg-gradient-to-r from-orange-500/10 to-green-400/10 border border-orange-500/20 rounded-lg">
          <h2 className="text-xl font-bold text-white mb-3">
            Licenza Unsplash
          </h2>
          <p className="text-gray-300 text-sm leading-relaxed mb-4">
            Tutte le foto utilizzate su questo sito sono rilasciate sotto la{' '}
            <a 
              href="https://unsplash.com/license" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-orange-500 hover:text-orange-400 underline"
            >
              Licenza Unsplash
            </a>, 
            che permette l'uso gratuito per scopi commerciali e non commerciali senza necessità di attribuzione 
            (anche se raccomandata come buona pratica).
          </p>
          <p className="text-gray-400 text-xs">
            © 2026 Performove Training_LAB. Questo sito rispetta i diritti d'autore e supporta la community di fotografi di Unsplash.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Ringraziamenti;
